module.exports = __webpack_public_path__ + "static/media/chat.773313a9.svg";